import axios from 'axios';
import { CATALOG_PAGE_ENDPOINTS } from "../constants";
export var fetchLowSpeedTariffs = function fetchLowSpeedTariffs(group) {
  return axios.get("".concat(CATALOG_PAGE_ENDPOINTS.request_low_speed_tariffs, "?group=").concat(group)).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};